import { Inject, Injectable, Injector } from '@angular/core';

import { IntraOne_ReportService } from './IntraOne.report.index';


@Injectable({ providedIn: 'root' })
export class app_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.IntraOne = this.injector.get(IntraOne_ReportService);
  }
    public IntraOne: IntraOne_ReportService;

  public app: app_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

